// Common searchable fields in USPTO patent data
// Based on swagger.yaml PatentDataResponse schema
export const searchableFields = [
  // Application basic info
  { field: 'applicationNumberText', label: 'Application Number', type: 'text' },
  { field: 'applicationMetaData.applicationTypeCode', label: 'Application Type Code', type: 'text' },
  { field: 'applicationMetaData.applicationTypeLabelName', label: 'Application Type Name', type: 'text' },
  { field: 'applicationMetaData.applicationStatusCode', label: 'Application Status Code', type: 'number' },
  { field: 'applicationMetaData.applicationStatusDescriptionText', label: 'Application Status Description', type: 'text' },
  { field: 'applicationMetaData.applicationStatusDate', label: 'Application Status Date', type: 'date' },
  
  // Applicant/Inventor info
  { field: 'applicationMetaData.firstApplicantName', label: 'First Applicant Name', type: 'text' },
  { field: 'applicationMetaData.firstInventorName', label: 'First Inventor Name', type: 'text' },
  { field: 'applicationMetaData.inventorBag.inventorNameText', label: 'Inventor Name', type: 'text' },
  { field: 'applicationMetaData.applicantBag.applicantNameText', label: 'Applicant Name', type: 'text' },
  
  // Dates
  { field: 'applicationMetaData.filingDate', label: 'Filing Date', type: 'date' },
  { field: 'applicationMetaData.effectiveFilingDate', label: 'Effective Filing Date', type: 'date' },
  { field: 'applicationMetaData.grantDate', label: 'Grant Date', type: 'date' },
  { field: 'applicationMetaData.publicationDateBag', label: 'Publication Date', type: 'date' },
  
  // Patent info
  { field: 'applicationMetaData.patentNumber', label: 'Patent Number', type: 'text' },
  { field: 'applicationMetaData.inventionTitle', label: 'Invention Title', type: 'text' },
  { field: 'applicationMetaData.docketNumber', label: 'Docket Number', type: 'text' },
  
  // Classification
  { field: 'applicationMetaData.groupArtUnitNumber', label: 'Group Art Unit Number', type: 'text' },
  { field: 'applicationMetaData.class', label: 'USPC Class', type: 'text' },
  { field: 'applicationMetaData.subclass', label: 'USPC Subclass', type: 'text' },
  { field: 'applicationMetaData.cpcClassificationBag', label: 'CPC Classification', type: 'text' },
  
  // Publication
  { field: 'applicationMetaData.publicationCategoryBag', label: 'Publication Category', type: 'text' },
  { field: 'applicationMetaData.publicationSequenceNumberBag', label: 'Publication Sequence Number', type: 'text' },
  { field: 'applicationMetaData.earliestPublicationNumber', label: 'Earliest Publication Number', type: 'text' },
  { field: 'applicationMetaData.earliestPublicationDate', label: 'Earliest Publication Date', type: 'date' },
  
  // Entity status
  { field: 'applicationMetaData.entityStatusData.smallEntityStatusIndicator', label: 'Small Entity Status', type: 'boolean' },
  { field: 'applicationMetaData.entityStatusData.businessEntityStatusCategory', label: 'Business Entity Status', type: 'text' },
  
  // Other
  { field: 'applicationMetaData.firstInventorToFileIndicator', label: 'First Inventor to File', type: 'text' },
  { field: 'applicationMetaData.nationalStageIndicator', label: 'National Stage Indicator', type: 'boolean' },
  { field: 'applicationMetaData.examinerNameText', label: 'Examiner Name', type: 'text' },
  { field: 'applicationMetaData.customerNumber', label: 'Customer Number', type: 'text' },
  { field: 'applicationMetaData.applicationConfirmationNumber', label: 'Application Confirmation Number', type: 'number' },
  
  // PCT info
  { field: 'applicationMetaData.pctPublicationNumber', label: 'PCT Publication Number', type: 'text' },
  { field: 'applicationMetaData.pctPublicationDate', label: 'PCT Publication Date', type: 'date' },
  
  // Assignment info
  { field: 'assignmentBag.reelNumber', label: 'Assignment Reel Number', type: 'text' },
  { field: 'assignmentBag.frameNumber', label: 'Assignment Frame Number', type: 'text' },
  { field: 'assignmentBag.assignmentReceivedDate', label: 'Assignment Received Date', type: 'date' },
  { field: 'assignmentBag.assignmentRecordedDate', label: 'Assignment Recorded Date', type: 'date' },
  { field: 'assignmentBag.conveyanceText', label: 'Assignment Conveyance Text', type: 'text' },
  { field: 'assignmentBag.assignorBag.assignorName', label: 'Assignor Name', type: 'text' },
  { field: 'assignmentBag.assigneeBag.assigneeNameText', label: 'Assignee Name', type: 'text' },
  
  // Continuity
  { field: 'parentContinuityBag.parentPatentNumber', label: 'Parent Patent Number', type: 'text' },
  { field: 'parentContinuityBag.parentApplicationNumberText', label: 'Parent Application Number', type: 'text' },
  { field: 'parentContinuityBag.parentApplicationFilingDate', label: 'Parent Filing Date', type: 'date' },
  { field: 'childContinuityBag.childPatentNumber', label: 'Child Patent Number', type: 'text' },
  { field: 'childContinuityBag.childApplicationNumberText', label: 'Child Application Number', type: 'text' },
  
  // Foreign priority
  { field: 'foreignPriorityBag.ipOfficeName', label: 'Foreign IP Office', type: 'text' },
  { field: 'foreignPriorityBag.filingDate', label: 'Foreign Filing Date', type: 'date' },
  { field: 'foreignPriorityBag.applicationNumberText', label: 'Foreign Application Number', type: 'text' },
];

export default searchableFields;
